import React from 'react'
import PropTypes from 'prop-types'
import { TimePicker } from 'antd'
import { useFormContext, Controller } from 'react-hook-form'
import { FormDatePicker } from '../../../../components/form'
import { DEFAULT_VALUE } from '..'
import { Wrapper } from './styled'

export const DueDateTime = ({ t, isRequired, disabled, wrapperProps = {}, dateProps = {}, timeProps = {} }) => {
  const { control } = useFormContext()

  return (
    <Wrapper {...wrapperProps}>
      <div className="date">
        <FormDatePicker
          t={t}
          name="dueDate"
          label={t('task.due_date')}
          defaultValue={DEFAULT_VALUE.dueDate}
          isRequired={isRequired}
          allowClear={false}
          useDate
          disabled={disabled}
          wrapperProps={{
            colon: false,
            labelAlign: 'left'
          }}
          {...dateProps}
        />
      </div>
      <div className="time">
        <Controller
          name="dueTime"
          control={control}
          render={({ field }) => (
            <TimePicker
              {...field}
              format="HH:mm"
              use12Hours={false}
              value={field.value}
              onChange={field.onChange}
              disabled={disabled}
              {...timeProps}
            />
          )}
        />
      </div>
    </Wrapper>
  )
}

DueDateTime.propTypes = {
  t: PropTypes.func,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  wrapperProps: PropTypes.object,
  dateProps: PropTypes.object,
  timeProps: PropTypes.object,
  timeDefaultValue: PropTypes.number
}
